import { useTranslation } from "react-i18next";
import { useState, useCallback } from "react";
import { getStudents} from "../../../../services/studentService";
import { message } from "antd";
import { StudentType } from "../../../../types/studentTypes";
import { useSelector } from "react-redux";

const useStudentTeacher = (
) => {
  const { t } = useTranslation();
  const [students, setStudents] = useState<StudentType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [error, setError] = useState<string | null>(null);

  const teacherId = useSelector((state: any) => state.authSlice.user?.roleId);


  const fetchStudentsTeacher = useCallback(async (filters: any = { page: 1, limit: 10 }) => {
    if (!teacherId) return;
    setIsLoading(true);
    try {
      const response = await getStudents({ ...filters, teacherId });
      setStudents(response.data);
      setPagination(response.pagination)
      setError(null)
    } catch (error) {
      setStudents([])
      setError(t("errors.ERROR_FETCHING_DATA"))
    } finally {
      setIsLoading(false);
    }
  }, [teacherId]);



  return {
    students,
    isLoading,
    pagination,
    error,
    fetchStudentsTeacher
  };
};

export default useStudentTeacher;
